import { useTranslation } from 'next-i18next';

import { NS } from '@/constants';

import CheckoutContainer from '@/components/checkout/common/CheckoutContainer';
import Login from '@/components/common/Login/index';

import styles from './CheckoutLogin.module.scss';

export const CheckoutLogin = (): React.JSX.Element => {
  const t = useTranslation(NS.COMMON).t;

  return (
    <CheckoutContainer customClass={styles['no-padding']}>
      <Login t={t} />
    </CheckoutContainer>
  );
};

export default CheckoutLogin;
